/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

/**
 * Internal dependencies
 */
import { sortObjectKeysUsingValue } from '../utils/formatters';

export const countries = sortObjectKeysUsingValue( {
	AF: _x( 'Afghanistan', 'text', 'nelio-forms' ),
	AX: _x( 'Åland Islands', 'text', 'nelio-forms' ),
	AL: _x( 'Albania', 'text', 'nelio-forms' ),
	DZ: _x( 'Algeria', 'text', 'nelio-forms' ),
	AS: _x( 'American Samoa', 'text', 'nelio-forms' ),
	AD: _x( 'Andorra', 'text', 'nelio-forms' ),
	AO: _x( 'Angola', 'text', 'nelio-forms' ),
	AI: _x( 'Anguilla', 'text', 'nelio-forms' ),
	AQ: _x( 'Antarctica', 'text', 'nelio-forms' ),
	AG: _x( 'Antigua and Barbuda', 'text', 'nelio-forms' ),
	AR: _x( 'Argentina', 'text', 'nelio-forms' ),
	AM: _x( 'Armenia', 'text', 'nelio-forms' ),
	AW: _x( 'Aruba', 'text', 'nelio-forms' ),
	AU: _x( 'Australia', 'text', 'nelio-forms' ),
	AT: _x( 'Austria', 'text', 'nelio-forms' ),
	AZ: _x( 'Azerbaijan', 'text', 'nelio-forms' ),
	BS: _x( 'Bahamas', 'text', 'nelio-forms' ),
	BH: _x( 'Bahrain', 'text', 'nelio-forms' ),
	BD: _x( 'Bangladesh', 'text', 'nelio-forms' ),
	BB: _x( 'Barbados', 'text', 'nelio-forms' ),
	BY: _x( 'Belarus', 'text', 'nelio-forms' ),
	BE: _x( 'Belgium', 'text', 'nelio-forms' ),
	BZ: _x( 'Belize', 'text', 'nelio-forms' ),
	BJ: _x( 'Benin', 'text', 'nelio-forms' ),
	BM: _x( 'Bermuda', 'text', 'nelio-forms' ),
	BT: _x( 'Bhutan', 'text', 'nelio-forms' ),
	BO: _x( 'Bolivia', 'text', 'nelio-forms' ),
	BQ: _x( 'Bonaire, Sint Eustatius and Saba', 'text', 'nelio-forms' ),
	BA: _x( 'Bosnia and Herzegovina', 'text', 'nelio-forms' ),
	BW: _x( 'Botswana', 'text', 'nelio-forms' ),
	BV: _x( 'Bouvet Island', 'text', 'nelio-forms' ),
	BR: _x( 'Brazil', 'text', 'nelio-forms' ),
	IO: _x( 'British Indian Ocean Territory', 'text', 'nelio-forms' ),
	BN: _x( 'Brunei Darussalam', 'text', 'nelio-forms' ),
	BG: _x( 'Bulgaria', 'text', 'nelio-forms' ),
	BF: _x( 'Burkina Faso', 'text', 'nelio-forms' ),
	BI: _x( 'Burundi', 'text', 'nelio-forms' ),
	KH: _x( 'Cambodia', 'text', 'nelio-forms' ),
	CM: _x( 'Cameroon', 'text', 'nelio-forms' ),
	CA: _x( 'Canada', 'text', 'nelio-forms' ),
	CV: _x( 'Cape Verde', 'text', 'nelio-forms' ),
	KY: _x( 'Cayman Islands', 'text', 'nelio-forms' ),
	CF: _x( 'Central African Republic', 'text', 'nelio-forms' ),
	TD: _x( 'Chad', 'text', 'nelio-forms' ),
	CL: _x( 'Chile', 'text', 'nelio-forms' ),
	CN: _x( 'China', 'text', 'nelio-forms' ),
	CX: _x( 'Christmas Island', 'text', 'nelio-forms' ),
	CC: _x( 'Cocos (Keeling) Islands', 'text', 'nelio-forms' ),
	CO: _x( 'Colombia', 'text', 'nelio-forms' ),
	KM: _x( 'Comoros', 'text', 'nelio-forms' ),
	CG: _x( 'Congo', 'text', 'nelio-forms' ),
	CD: _x( 'Congo, the Democratic Republic of the', 'text', 'nelio-forms' ),
	CK: _x( 'Cook Islands', 'text', 'nelio-forms' ),
	CR: _x( 'Costa Rica', 'text', 'nelio-forms' ),
	CI: _x( 'Côte d’Ivoire', 'text', 'nelio-forms' ),
	HR: _x( 'Croatia', 'text', 'nelio-forms' ),
	CU: _x( 'Cuba', 'text', 'nelio-forms' ),
	CW: _x( 'Curaçao', 'text', 'nelio-forms' ),
	CY: _x( 'Cyprus', 'text', 'nelio-forms' ),
	CZ: _x( 'Czech Republic', 'text', 'nelio-forms' ),
	DK: _x( 'Denmark', 'text', 'nelio-forms' ),
	DJ: _x( 'Djibouti', 'text', 'nelio-forms' ),
	DM: _x( 'Dominica', 'text', 'nelio-forms' ),
	DO: _x( 'Dominican Republic', 'text', 'nelio-forms' ),
	EC: _x( 'Ecuador', 'text', 'nelio-forms' ),
	EG: _x( 'Egypt', 'text', 'nelio-forms' ),
	SV: _x( 'El Salvador', 'text', 'nelio-forms' ),
	GQ: _x( 'Equatorial Guinea', 'text', 'nelio-forms' ),
	ER: _x( 'Eritrea', 'text', 'nelio-forms' ),
	EE: _x( 'Estonia', 'text', 'nelio-forms' ),
	SZ: _x( 'Eswatini', 'text', 'nelio-forms' ),
	ET: _x( 'Ethiopia', 'text', 'nelio-forms' ),
	FK: _x( 'Falkland Islands (Malvinas)', 'text', 'nelio-forms' ),
	FO: _x( 'Faroe Islands', 'text', 'nelio-forms' ),
	FJ: _x( 'Fiji', 'text', 'nelio-forms' ),
	FI: _x( 'Finland', 'text', 'nelio-forms' ),
	FR: _x( 'France', 'text', 'nelio-forms' ),
	GF: _x( 'French Guiana', 'text', 'nelio-forms' ),
	PF: _x( 'French Polynesia', 'text', 'nelio-forms' ),
	TF: _x( 'French Southern Territories', 'text', 'nelio-forms' ),
	GA: _x( 'Gabon', 'text', 'nelio-forms' ),
	GM: _x( 'Gambia', 'text', 'nelio-forms' ),
	GE: _x( 'Georgia', 'text', 'nelio-forms' ),
	DE: _x( 'Germany', 'text', 'nelio-forms' ),
	GH: _x( 'Ghana', 'text', 'nelio-forms' ),
	GI: _x( 'Gibraltar', 'text', 'nelio-forms' ),
	GR: _x( 'Greece', 'text', 'nelio-forms' ),
	GL: _x( 'Greenland', 'text', 'nelio-forms' ),
	GD: _x( 'Grenada', 'text', 'nelio-forms' ),
	GP: _x( 'Guadeloupe', 'text', 'nelio-forms' ),
	GU: _x( 'Guam', 'text', 'nelio-forms' ),
	GT: _x( 'Guatemala', 'text', 'nelio-forms' ),
	GG: _x( 'Guernsey', 'text', 'nelio-forms' ),
	GN: _x( 'Guinea', 'text', 'nelio-forms' ),
	GW: _x( 'Guinea-Bissau', 'text', 'nelio-forms' ),
	GY: _x( 'Guyana', 'text', 'nelio-forms' ),
	HT: _x( 'Haiti', 'text', 'nelio-forms' ),
	HM: _x( 'Heard Island and Mcdonald Islands', 'text', 'nelio-forms' ),
	VA: _x( 'Holy See (Vatican City State)', 'text', 'nelio-forms' ),
	HN: _x( 'Honduras', 'text', 'nelio-forms' ),
	HK: _x( 'Hong Kong', 'text', 'nelio-forms' ),
	HU: _x( 'Hungary', 'text', 'nelio-forms' ),
	IS: _x( 'Iceland', 'text', 'nelio-forms' ),
	IN: _x( 'India', 'text', 'nelio-forms' ),
	ID: _x( 'Indonesia', 'text', 'nelio-forms' ),
	IR: _x( 'Iran, Islamic Republic of', 'text', 'nelio-forms' ),
	IQ: _x( 'Iraq', 'text', 'nelio-forms' ),
	IE: _x( 'Ireland', 'text', 'nelio-forms' ),
	IM: _x( 'Isle of Man', 'text', 'nelio-forms' ),
	IL: _x( 'Israel', 'text', 'nelio-forms' ),
	IT: _x( 'Italy', 'text', 'nelio-forms' ),
	JM: _x( 'Jamaica', 'text', 'nelio-forms' ),
	JP: _x( 'Japan', 'text', 'nelio-forms' ),
	JE: _x( 'Jersey', 'text', 'nelio-forms' ),
	JO: _x( 'Jordan', 'text', 'nelio-forms' ),
	KZ: _x( 'Kazakhstan', 'text', 'nelio-forms' ),
	KE: _x( 'Kenya', 'text', 'nelio-forms' ),
	KI: _x( 'Kiribati', 'text', 'nelio-forms' ),
	XK: _x( 'Kosovo', 'text', 'nelio-forms' ),
	KP: _x( 'North Korea', 'text', 'nelio-forms' ),
	KR: _x( 'South Korea', 'text', 'nelio-forms' ),
	KW: _x( 'Kuwait', 'text', 'nelio-forms' ),
	KG: _x( 'Kyrgyzstan', 'text', 'nelio-forms' ),
	LA: _x( 'Lao People’s Democratic Republic', 'text', 'nelio-forms' ),
	LV: _x( 'Latvia', 'text', 'nelio-forms' ),
	LB: _x( 'Lebanon', 'text', 'nelio-forms' ),
	LS: _x( 'Lesotho', 'text', 'nelio-forms' ),
	LR: _x( 'Liberia', 'text', 'nelio-forms' ),
	LY: _x( 'Libya', 'text', 'nelio-forms' ),
	LI: _x( 'Liechtenstein', 'text', 'nelio-forms' ),
	LT: _x( 'Lithuania', 'text', 'nelio-forms' ),
	LU: _x( 'Luxembourg', 'text', 'nelio-forms' ),
	MO: _x( 'Macao', 'text', 'nelio-forms' ),
	MG: _x( 'Madagascar', 'text', 'nelio-forms' ),
	MW: _x( 'Malawi', 'text', 'nelio-forms' ),
	MY: _x( 'Malaysia', 'text', 'nelio-forms' ),
	MV: _x( 'Maldives', 'text', 'nelio-forms' ),
	ML: _x( 'Mali', 'text', 'nelio-forms' ),
	MT: _x( 'Malta', 'text', 'nelio-forms' ),
	MH: _x( 'Marshall Islands', 'text', 'nelio-forms' ),
	MQ: _x( 'Martinique', 'text', 'nelio-forms' ),
	MR: _x( 'Mauritania', 'text', 'nelio-forms' ),
	MU: _x( 'Mauritius', 'text', 'nelio-forms' ),
	YT: _x( 'Mayotte', 'text', 'nelio-forms' ),
	MX: _x( 'Mexico', 'text', 'nelio-forms' ),
	FM: _x( 'Micronesia, Federated States of', 'text', 'nelio-forms' ),
	MD: _x( 'Moldova, Republic of', 'text', 'nelio-forms' ),
	MC: _x( 'Monaco', 'text', 'nelio-forms' ),
	MN: _x( 'Mongolia', 'text', 'nelio-forms' ),
	ME: _x( 'Montenegro', 'text', 'nelio-forms' ),
	MS: _x( 'Montserrat', 'text', 'nelio-forms' ),
	MA: _x( 'Morocco', 'text', 'nelio-forms' ),
	MZ: _x( 'Mozambique', 'text', 'nelio-forms' ),
	MM: _x( 'Myanmar', 'text', 'nelio-forms' ),
	NA: _x( 'Namibia', 'text', 'nelio-forms' ),
	NR: _x( 'Nauru', 'text', 'nelio-forms' ),
	NP: _x( 'Nepal', 'text', 'nelio-forms' ),
	NL: _x( 'Netherlands', 'text', 'nelio-forms' ),
	NC: _x( 'New Caledonia', 'text', 'nelio-forms' ),
	NZ: _x( 'New Zealand', 'text', 'nelio-forms' ),
	NI: _x( 'Nicaragua', 'text', 'nelio-forms' ),
	NE: _x( 'Niger', 'text', 'nelio-forms' ),
	NG: _x( 'Nigeria', 'text', 'nelio-forms' ),
	NU: _x( 'Niue', 'text', 'nelio-forms' ),
	NF: _x( 'Norfolk Island', 'text', 'nelio-forms' ),
	MK: _x( 'North Macedonia, Republic of', 'text', 'nelio-forms' ),
	MP: _x( 'Northern Mariana Islands', 'text', 'nelio-forms' ),
	NO: _x( 'Norway', 'text', 'nelio-forms' ),
	OM: _x( 'Oman', 'text', 'nelio-forms' ),
	PK: _x( 'Pakistan', 'text', 'nelio-forms' ),
	PW: _x( 'Palau', 'text', 'nelio-forms' ),
	PS: _x( 'Palestinian Territory, Occupied', 'text', 'nelio-forms' ),
	PA: _x( 'Panama', 'text', 'nelio-forms' ),
	PG: _x( 'Papua New Guinea', 'text', 'nelio-forms' ),
	PY: _x( 'Paraguay', 'text', 'nelio-forms' ),
	PE: _x( 'Peru', 'text', 'nelio-forms' ),
	PH: _x( 'Philippines', 'text', 'nelio-forms' ),
	PN: _x( 'Pitcairn', 'text', 'nelio-forms' ),
	PL: _x( 'Poland', 'text', 'nelio-forms' ),
	PT: _x( 'Portugal', 'text', 'nelio-forms' ),
	PR: _x( 'Puerto Rico', 'text', 'nelio-forms' ),
	QA: _x( 'Qatar', 'text', 'nelio-forms' ),
	RE: _x( 'Reunion', 'text', 'nelio-forms' ),
	RO: _x( 'Romania', 'text', 'nelio-forms' ),
	RU: _x( 'Russian Federation', 'text', 'nelio-forms' ),
	RW: _x( 'Rwanda', 'text', 'nelio-forms' ),
	BL: _x( 'Saint Barthélemy', 'text', 'nelio-forms' ),
	SH: _x( 'Saint Helena', 'text', 'nelio-forms' ),
	KN: _x( 'Saint Kitts and Nevis', 'text', 'nelio-forms' ),
	LC: _x( 'Saint Lucia', 'text', 'nelio-forms' ),
	MF: _x( 'Saint Martin (French part)', 'text', 'nelio-forms' ),
	PM: _x( 'Saint Pierre and Miquelon', 'text', 'nelio-forms' ),
	VC: _x( 'Saint Vincent and the Grenadines', 'text', 'nelio-forms' ),
	WS: _x( 'Samoa', 'text', 'nelio-forms' ),
	SM: _x( 'San Marino', 'text', 'nelio-forms' ),
	ST: _x( 'Sao Tome and Principe', 'text', 'nelio-forms' ),
	SA: _x( 'Saudi Arabia', 'text', 'nelio-forms' ),
	SN: _x( 'Senegal', 'text', 'nelio-forms' ),
	RS: _x( 'Serbia', 'text', 'nelio-forms' ),
	SC: _x( 'Seychelles', 'text', 'nelio-forms' ),
	SL: _x( 'Sierra Leone', 'text', 'nelio-forms' ),
	SG: _x( 'Singapore', 'text', 'nelio-forms' ),
	SX: _x( 'Sint Maarten (Dutch part)', 'text', 'nelio-forms' ),
	SK: _x( 'Slovakia', 'text', 'nelio-forms' ),
	SI: _x( 'Slovenia', 'text', 'nelio-forms' ),
	SB: _x( 'Solomon Islands', 'text', 'nelio-forms' ),
	SO: _x( 'Somalia', 'text', 'nelio-forms' ),
	ZA: _x( 'South Africa', 'text', 'nelio-forms' ),
	GS: _x(
		'South Georgia and the South Sandwich Islands',
		'text',
		'nelio-forms'
	),
	SS: _x( 'South Sudan', 'text', 'nelio-forms' ),
	ES: _x( 'Spain', 'text', 'nelio-forms' ),
	LK: _x( 'Sri Lanka', 'text', 'nelio-forms' ),
	SD: _x( 'Sudan', 'text', 'nelio-forms' ),
	SR: _x( 'Suriname', 'text', 'nelio-forms' ),
	SJ: _x( 'Svalbard and Jan Mayen', 'text', 'nelio-forms' ),
	SE: _x( 'Sweden', 'text', 'nelio-forms' ),
	CH: _x( 'Switzerland', 'text', 'nelio-forms' ),
	SY: _x( 'Syrian Arab Republic', 'text', 'nelio-forms' ),
	TW: _x( 'Taiwan', 'text', 'nelio-forms' ),
	TJ: _x( 'Tajikistan', 'text', 'nelio-forms' ),
	TZ: _x( 'Tanzania, United Republic of', 'text', 'nelio-forms' ),
	TH: _x( 'Thailand', 'text', 'nelio-forms' ),
	TL: _x( 'Timor-Leste', 'text', 'nelio-forms' ),
	TG: _x( 'Togo', 'text', 'nelio-forms' ),
	TK: _x( 'Tokelau', 'text', 'nelio-forms' ),
	TO: _x( 'Tonga', 'text', 'nelio-forms' ),
	TT: _x( 'Trinidad and Tobago', 'text', 'nelio-forms' ),
	TN: _x( 'Tunisia', 'text', 'nelio-forms' ),
	TR: _x( 'Turkey', 'text', 'nelio-forms' ),
	TM: _x( 'Turkmenistan', 'text', 'nelio-forms' ),
	TC: _x( 'Turks and Caicos Islands', 'text', 'nelio-forms' ),
	TV: _x( 'Tuvalu', 'text', 'nelio-forms' ),
	UG: _x( 'Uganda', 'text', 'nelio-forms' ),
	UA: _x( 'Ukraine', 'text', 'nelio-forms' ),
	AE: _x( 'United Arab Emirates', 'text', 'nelio-forms' ),
	GB: _x( 'United Kingdom', 'text', 'nelio-forms' ),
	US: _x( 'United States of America', 'text', 'nelio-forms' ),
	UM: _x( 'United States Minor Outlying Islands', 'text', 'nelio-forms' ),
	UY: _x( 'Uruguay', 'text', 'nelio-forms' ),
	UZ: _x( 'Uzbekistan', 'text', 'nelio-forms' ),
	VU: _x( 'Vanuatu', 'text', 'nelio-forms' ),
	VE: _x( 'Venezuela', 'text', 'nelio-forms' ),
	VN: _x( 'Vietnam', 'text', 'nelio-forms' ),
	VG: _x( 'Virgin Islands, British', 'text', 'nelio-forms' ),
	VI: _x( 'Virgin Islands, U.S.', 'text', 'nelio-forms' ),
	WF: _x( 'Wallis and Futuna', 'text', 'nelio-forms' ),
	EH: _x( 'Western Sahara', 'text', 'nelio-forms' ),
	YE: _x( 'Yemen', 'text', 'nelio-forms' ),
	ZM: _x( 'Zambia', 'text', 'nelio-forms' ),
	ZW: _x( 'Zimbabwe', 'text', 'nelio-forms' ),
} );
